/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from 'react';
import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer';
import assets from '../../assets';

import { formatDinheiro } from '../../utils/formatDinheiro';
import { useApi } from '../../hooks/userApi';

Font.register({
  family: 'Source Sans Pro',
  src: require('../../assets/fonts/source-sans-pro.ttf'),
});
Font.register({
  family: 'Source Sans Bold',
  src: require('../../assets/fonts/source-sans-pro.bold.ttf'),
});
Font.register({
  family: 'Source Sans SemiBold',
  src: require('../../assets/fonts/source-sans-pro.semibold.ttf'),
});

const styles = StyleSheet.create({
  body: {},
  viewer: {
    width: window.innerWidth, //the pdf viewer will take up all of the width and height
    height: window.innerHeight,
  },
  title: {
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Source Sans Bold',
    color: '#136033',
  },
  validade: {
    fontSize: 8,
    textAlign: 'center',
    color: '#B8B8B8',
  },
  subtitle: {
    fontSize: 9,
    textAlign: 'center',
    paddingTop: 6,
    color: '#136033',
    fontFamily: 'Source Sans SemiBold',
    width: 137,
    height: 24,
    backgroundColor: '#FAFAFA',
    borderBottomRightRadius: 20,
  },
  proposta: {
    fontSize: 14,
    textAlign: 'right',
  },
  observacoes: {
    fontSize: 9,
    width: 311,
    height: 85,
    textAlign: 'left',
    backgroundColor: '#FAFAFA',
    borderRadius: 4,
    color: '#7E7E7E',
    paddingTop: 14,
    paddingLeft: 10,
    paddingRight: 10,
    marginLeft: 32,
    marginTop: 11,
  },
  text: {
    fontSize: 9,
    textAlign: 'justify',
    color: '#7E7E7E',
  },
  bold: {
    fontFamily: 'Source Sans Bold',
    color: '#3d3d3d',
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 12,
    width: '100%',
    marginBottom: 20,
    backgroundColor: '#F5F5F5',
    height: 80,
    borderBottom: 'solid',
    borderColor: '#E0E0E0',
    borderBottomWidth: 1,
    textAlign: 'center',
  },
  headerImage: {
    width: 110,
    height: 48,
    paddingRight: 26,
    marginLeft: 32,
    borderRight: 'solid',
    borderColor: '#A5CD39',
    borderRightWidth: 1,
  },
  blocoValores: {
    backgroundColor: '#FAFAFA',
    width: 211,
    marginLeft: 9,
    height: 88,
    borderRadius: 4,
    paddingLeft: 12,
    paddingTop: 20,
  },
  condicoes: {
    backgroundColor: '#FAFAFA',
    width: 211,
    marginTop: 9,
    borderRadius: 4,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 20,
    paddingBottom: 20,
  },
  blocoText: {
    marginLeft: 32,
    marginTop: 8,
    marginBottom: 16,
  },
  valorTotal: {
    backgroundColor: '#136033',
    height: 32,
    fontSize: 14,
    marginLeft: 9,
    fontFamily: 'Source Sans Bold',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    color: '#FAFAFA',
    paddingTop: 6,
    paddingLeft: 12,
  },
  headerText: {
    display: 'flex',
    fontFamily: 'Source Sans Pro',
    fontSize: 8,
    width: 185,
    color: '#585858',
    textAlign: 'left',
    flexDirection: 'column',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  table: {
    display: 'flex',
    width: '100%',
    marginTop: 8,
    paddingLeft: 10,
    paddingRight: 20,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
  },
  tableCellTitulos: {
    margin: 'auto',
    marginTop: 5,
    color: '#7E7E7E',
    fontSize: 8,
  },
  tableCellProduto: {
    margin: 'auto',
    marginTop: 5,
    color: '#136033',
    fontSize: 8,
    fontFamily: 'Source Sans SemiBold',
  },
  tableCol: {
    width: '8.5%',
  },
  tableCell: {
    margin: 'auto',
    marginTop: 5,
    fontSize: 10,
  },
});

// {[  "Código",  "Produto",  "Qtde.",  "Unitário",  "Frete",  "Vlr. Total",  "%IPI",  "Vlr. IPI",]}
const Table = ({ ths, tds, setP, orcamento }) => {
  const [produtos, setProdutos] = useState<any>([]);

  useEffect(() => {
    setProdutos([]);
    // eslint-disable-next-line prefer-const
    let orcTotal = {
      TotalItens: 0,
      TotalIpi: 0,
      TotalFrete: 0,
    };
    tds.map((p, index) => {
      const item: any = [];
      const ipi = orcamento?.[index].ipi / 100;
      const valorTotal = p.valor * ipi * p.quantidade + p.valorFrete * ipi;
      item.push(p.SKU);
      item.push(p.nome);
      item.push(p.quantidade);
      item.push(formatDinheiro(p.valor, 4));
      item.push(formatDinheiro(p.valorFrete, 2));
      item.push(new Intl.NumberFormat().format(Number(orcamento?.[index].ipi)) + ' %');
      item.push(formatDinheiro(valorTotal, 2));
      item.push(formatDinheiro(p.valor * p.quantidade, 2));
      setProdutos((produtos) => [...produtos, item]);

      orcTotal.TotalItens += p.valor * p.quantidade;
      orcTotal.TotalIpi += valorTotal;
      orcTotal.TotalFrete += Number(p.valorFrete);
      setP(orcTotal);
    });
  }, [tds]);

  return (
    <View style={styles.table}>
      <View style={styles.tableRow}>
        {ths.map((th, index) => (
          <View style={index === 1 ? { ...styles.tableCol, width: '40%' } : styles.tableCol}>
            <Text style={styles.tableCellTitulos}>{th}</Text>
          </View>
        ))}
      </View>
      {produtos.map((produto) => (
        <View style={styles.tableRow}>
          {produto.map((e, index) => (
            <View style={index === 1 ? { ...styles.tableCol, width: '40%' } : styles.tableCol}>
              <Text style={styles.tableCellProduto}>{e}</Text>
            </View>
          ))}
        </View>
      ))}
    </View>
  );
};

const Cliente = ({ cliente }) => {
  return (
    <View style={[styles.text, styles.blocoText, { display: 'flex', flexDirection: 'row', gap: '10px' }]}>
      <View style={{ display: 'flex', flexDirection: 'row' }}>
        <View style={{ marginRight: '20px' }}>
          {cliente?.nome && (
            <Text>
              Cliente:
              <Text style={styles.bold}>{cliente.nome}</Text>
            </Text>
          )}
          {cliente?.cpfCNPJ && !cliente.cpfCNPJ.startsWith('lead') && (
            <Text>
              CPF/CNPJ:
              <Text style={styles.bold}>{cliente.cpfCNPJ}</Text>
            </Text>
          )}
          {cliente?.tipoDocumento && cliente?.documento && (
            <Text>
              Documento:
              <Text style={styles.bold}>
                {cliente.tipoDocumento} - {cliente.documento}
              </Text>
            </Text>
          )}
          {cliente?.razaoSocial && (
            <Text>
              Razão social:
              <Text style={styles.bold}>{cliente.razaoSocial}</Text>
            </Text>
          )}
          {cliente?.nomeFantasia && (
            <Text>
              Nome fantasia:
              <Text style={styles.bold}>{cliente.nomeFantasia}</Text>
            </Text>
          )}
        </View>
        <View>
          {cliente?.email && (
            <Text>
              E-mail:
              <Text style={styles.bold}>{cliente.email}</Text>
            </Text>
          )}
          {cliente?.telefone && (
            <Text>
              Telefone:
              <Text style={styles.bold}>{cliente.telefone}</Text>
            </Text>
          )}
          {cliente?.whatsapp && (
            <Text>
              Whatsapp:
              <Text style={styles.bold}>{cliente.whatsapp}</Text>
            </Text>
          )}
          {cliente?.endereco && cliente?.numero && cliente?.cidade && cliente?.cep && (
            <Text>
              Endereço:
              <Text style={styles.bold}>
                {cliente.endereco} {cliente.numero} {cliente.complemento} - {cliente.cidade} {cliente.cep} {'\n'}
                {cliente.estado}
              </Text>
            </Text>
          )}
        </View>
      </View>
    </View>
  );
};

const Vendedor = ({ vendedor }) => {
  console.log('PDF - Componente Vendedor recebido:', vendedor);
  console.log('PDF - emailContato:', vendedor.emailContato);
  console.log('PDF - email:', vendedor.email);
  console.log('PDF - Todos os campos do vendedor:', Object.keys(vendedor));

  const emailFields = Object.keys(vendedor).filter((key) => key.toLowerCase().includes('email'));
  console.log('PDF - Campos que contêm "email":', emailFields);

  const userFromSession = JSON.parse(sessionStorage.getItem('user') || '{}');
  console.log('PDF - Usuário do sessionStorage:', userFromSession);

  const emailFinal =
    vendedor.emailContato && vendedor.emailContato !== 'SEM'
      ? vendedor.emailContato
      : vendedor.email || userFromSession.email || 'N/A';
  console.log('PDF - Email final calculado:', emailFinal);
  return (
    <View style={[styles.text, styles.blocoText, { display: 'flex', flexDirection: 'row', gap: '10px' }]}>
      <View style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <Text>
          Nome:
          <Text style={styles.bold}>{vendedor.nome}</Text>
        </Text>
        <Text>
          E-mail:
          <Text style={styles.bold}>{emailFinal}</Text>
        </Text>
        <Text>
          Contato:
          <Text style={styles.bold}>{vendedor.contato}</Text>
        </Text>
      </View>
    </View>
  );
};

const PrintPDF = ({ orcamento, adjustedEmbarque }) => {
  const [vendedor, setVendedor] = useState<any>({});
  const [cliente, setCliente] = useState<any>({});
  const [produtos, setProdutos] = useState<any>([]);
  const [valorComDesconto, setValorComDesconto] = useState(0);
  const [somaOrcamento, setSomaOrcamento] = useState<any>({});
  const api = useApi();

  const getVendedor = async () => {
    const vendedorData = orcamento?.[0].orcamento.vendedor;
    console.log('PDF - Dados originais do vendedor:', vendedorData);
    setVendedor(vendedorData);

    if (vendedorData && vendedorData.id) {
      try {
        const response = await api.get(`/vendedor/${vendedorData.id}`);
        console.log('PDF - Resposta da API:', response);
        if (response.status) {
          console.log('PDF - Dados atualizados do vendedor:', response.mensagem);
          setVendedor(response.mensagem);
        }
      } catch (e) {
        console.error('PDF - Erro ao carregar dados atualizados do vendedor:', e);
      }
    }
  };

  const getCliente = () => {
    setCliente(orcamento?.[0].orcamento.cliente);
  };

  const getProdutos = () => {
    orcamento.map((e, index) => {
      const p = { ...e.produto };
      p.valor = e.valor;
      p.quantidade = e.quantidade;
      p.valorFrete = e.valorFrete;
      setProdutos((produtos) => [...produtos, p]);
    });
  };

  useEffect(() => {
    setSomaOrcamento({});
    setProdutos([]);
    getVendedor();
    getCliente();
    getProdutos();
  }, []);

  const setP = (p) => {
    setSomaOrcamento(p);
  };

  useEffect(() => {
    const calculaDesconto = () => {
      const valorTotalResult =
        somaOrcamento?.TotalItens +
        somaOrcamento?.TotalFrete +
        somaOrcamento?.TotalIpi -
        Number(Number(orcamento?.[0].orcamento?.descontoFrete).toFixed(2)) +
        Number(orcamento?.[0].orcamento?.despesas);
      const valorTotalComDesconto = orcamento?.[0].orcamento.negociacao.includes('3% de Desconto À VISTA')
        ? valorTotalResult - valorTotalResult * 0.03
        : valorTotalResult;
      setValorComDesconto(valorTotalComDesconto);
      console.log(valorTotalResult);
    };

    calculaDesconto();
  }, [
    somaOrcamento?.TotalItens +
      somaOrcamento?.TotalFrete +
      somaOrcamento?.TotalIpi -
      Number(Number(orcamento?.[0].orcamento?.descontoFrete).toFixed(2)),
  ]);

  return (
    <Document>
      <Page style={styles.body}>
        <View style={styles.header} fixed>
          <Image style={styles.headerImage} src={assets.images.logoPDF} />
          <View style={styles.headerText}>
            <Text>Primaza Termoplástico LTDA | CNPJ: 06.350.668/0001-45</Text>
            <Text>Av. Presidente Kennedy, 3400 | Panambi-RS | 98280-000</Text>
          </View>
          <View style={styles.headerText}>
            <Text>Fone: 55 3375-8443 / WhatsApp: 55 99675-4640</Text>
            <Text>vendas@primaza.com.br</Text>
          </View>
        </View>
        <Text style={styles.title}>Orçamento {orcamento?.[0].orcamento.cod}</Text>
        <Text style={styles.validade}>
          Gerado em {new Date(orcamento?.[0].orcamento.created_at).toLocaleDateString('pt-br')}
        </Text>
        <Text style={styles.subtitle}>Dados do Cliente</Text>
        <Cliente cliente={cliente} />
        <Text style={styles.subtitle}>Produto</Text>
        <Table
          ths={['SKU', 'Produto', 'Qtde.', 'Unitário', 'Frete', '%IPI', 'Vlr. IPI', 'Vlr. Total']}
          tds={produtos}
          setP={setP}
          orcamento={orcamento}
        />
        <View style={[{ display: 'flex', flexDirection: 'row', marginTop: 22 }]}>
          <View>
            <Text style={styles.subtitle}>Observações:</Text>
            <Text style={styles.observacoes}>
              {orcamento?.[0].orcamento.observacoes ? orcamento?.[0].orcamento.observacoes : 'Nenhuma observação'}
            </Text>
          </View>
          <View>
            <View style={styles.blocoValores}>
              <Text style={[styles.text, { marginBottom: 2 }]}>
                Valor total Itens:
                <Text style={styles.bold}>{formatDinheiro(somaOrcamento?.TotalItens, 2)}</Text>
              </Text>
              <Text style={[styles.text, { marginBottom: 2 }]}>
                Valor IPI:
                <Text style={styles.bold}>{formatDinheiro(somaOrcamento?.TotalIpi, 2)}</Text>
              </Text>
              <Text style={[styles.text, { marginBottom: 2 }]}>
                Valor Frete:
                <Text style={styles.bold}>{formatDinheiro(somaOrcamento?.TotalFrete, 2)}</Text>
              </Text>
              {Number(orcamento?.[0].orcamento?.descontoFrete) > 0 && (
                <Text style={[styles.text, { marginBottom: 2 }]}>
                  Valor do Desconto:
                  <Text style={styles.bold}>{formatDinheiro(orcamento?.[0].orcamento?.descontoFrete, 2)}</Text>
                </Text>
              )}
              <Text style={[styles.text, { marginBottom: 2 }]}>
                Despesas:
                <Text style={styles.bold}>{formatDinheiro(orcamento?.[0].orcamento?.despesas, 2)}</Text>
              </Text>
            </View>
            <Text style={[styles.valorTotal, styles.bold, { color: 'white' }]}>
              Total:{' '}
              {formatDinheiro(
                somaOrcamento?.TotalItens +
                  somaOrcamento?.TotalFrete +
                  somaOrcamento?.TotalIpi -
                  Number(Number(orcamento?.[0].orcamento?.descontoFrete).toFixed(2)) +
                  Number(orcamento?.[0].orcamento?.despesas),
                2,
              )}
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', marginRight: 32 }}>
          <View style={[styles.condicoes]}>
            {orcamento?.[0].orcamento.negociacao.length > 0 && (
              <>
                <Text style={[styles.text, { marginBottom: 2 }]}>Condição de negociação</Text>
                <Text style={[styles.text, { marginBottom: 2 }]}>
                  Método de pagamento:
                  <Text style={styles.bold}>{orcamento?.[0].orcamento.pagamento.nome}</Text>
                  {' - '}
                  {orcamento?.[0].orcamento.negociacao.map((item, index) => (
                    <Text key={index} style={[styles.text, styles.bold]}>
                      {item + (index < orcamento?.[0].orcamento.negociacao.length - 1 ? ' - ' : ' ')}
                    </Text>
                  ))}
                </Text>
              </>
            )}
            <Text style={[styles.text, { marginBottom: 2, color: 'rgb(19, 96, 51)' }]}>
              Frete:
              <Text style={[styles.bold, { color: 'rgb(19, 96, 51)' }]}>{orcamento?.[0].orcamento?.tipofrete}</Text>
            </Text>
            <Text style={styles.text}>
              Prazo de embarque:
              <Text style={styles.bold}>{new Date(adjustedEmbarque).toLocaleDateString('pt-br')}</Text>
            </Text>
            {orcamento?.[0].orcamento.negociacao.includes('3% de Desconto À VISTA') && (
              <Text style={[styles.text, { marginBottom: 2 }]}>
                Total à vista com desconto:
                <Text style={styles.bold}>{formatDinheiro(valorComDesconto)}</Text>
              </Text>
            )}
            <Text style={[styles.text, { marginBottom: 2, color: '#43805C' }]}>
              Validade da proposta:
              <Text style={[styles.bold, { color: '#43805C' }]}>
                {new Date(orcamento?.[0].orcamento.validade).toLocaleDateString('pt-br')}
              </Text>
            </Text>
          </View>
        </View>
        <View style={styles.pageNumber}>
          <Text style={styles.subtitle}>Vendedor</Text>
          <Vendedor vendedor={vendedor} />
        </View>
        <View style={[styles.pageNumber, { backgroundColor: '#136033', height: 8, bottom: 0 }]}> </View>
        {/* <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
          fixed
        /> */}
      </Page>
    </Document>
  );
};
export default PrintPDF;
